<template>
  <div class="relative">
    <ul class="grid cols-4 gap-2 md:cols-5">
      <li v-for="({ color, id, label, disabled }, i) in filter.options" :key="`${id}-${i}`">
        <base-toggle
          v-model="model"
          v-bind="{ value: id, disabled }"
          class="min-h-24 f-col items-center gap-y-1 b rounded-sm px-2 pb-1 pt-3 between"
          :class="model?.includes?.(id) ? 'b-grey-10' : 'b-grey-70'"
          data-test-id="vf-color-filter"
        >
          <vf-color-swatch
            :id
            class="aspect-square"
            class-inner="rounded-sm"
            :color
            style="width: 2.625rem"
          />
          <span
            class="line-clamp-2 max-w-full truncate text-center text-xs font-secondary uppercase"
            :class="{ 'c-grey-30': disabled }"
          >
            {{ label }}
          </span>
        </base-toggle>
      </li>
    </ul>
    <div v-if="loading" class="absolute-0 bg-white op-50" />
  </div>
</template>

<script lang="ts" setup>
import type { ColorFilter } from '#types/filters'

defineProps<{
  filter: ColorFilter
  loading?: boolean
}>()

const model = defineModel<string[]>()
</script>
